module.exports = __webpack_public_path__ + "img/logo.ff0cf5fc.png";